import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type StatCardTone = 'primary' | 'caution' | 'info' | 'success' | 'alert';

@Component({
  selector: 'app-stat-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stat-card.component.html',
  styleUrl: './stat-card.component.scss',
})
export class StatCardComponent {
  @Input() icon = '';
  @Input() value: number | string = 0;
  @Input() label = '';
  @Input() tone: StatCardTone = 'primary';
  @Input() ariaLabel = '';

  get accessibleText(): string {
    return this.ariaLabel || `${this.value} ${this.label}`;
  }
}
